import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import MainInput from "../../../component/atoms/input/mainInput";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import TableLayout from "../../../component/atoms/layout/table/tableLayout";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import TableTab02 from "../../../component/molecules/tableTab02";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { route } from "../../../router/route";
import BasicApi from "../../../api/basic.api";
import { errorHandler } from "../../../util/errorHandler";
import { toastMsg } from "../../../util/toastMsg";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";

const SubscribeSetting = () => {
  const pageList = [
    {
      title: "구독 내역",
      link: route.payment_subscribe_list,
      originLink: route.payment_subscribe_list,
    },
    {
      title: "구독 관리",
      link: route.payment_subscribe_setting,
      originLink: route.payment_subscribe_setting,
    },
  ];

  const [subscribeData, setSubscribeData] = useState(0);
  const [basicInfo, setBasicInfo] = useState({});

  const getBasicInfo = async () => {
    try {
      let data = (await BasicApi.getBasicInfo()).data.data.content;

      setSubscribeData(data.membershipPrice);
      setBasicInfo(data);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    getBasicInfo();
  }, []);

  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveBtnHandler = () => {
    const membershipPrice = Number(subscribeData);
    if (!Number.isFinite(membershipPrice) || membershipPrice <= 0) {
      return toast("구독 금액은 0보다 크게 입력해주세요.");
    }

    setSaveModalOpen(true);
  };

  const saveFunc = async () => {
    try {
      const data = {
        ...basicInfo,
        membershipPrice: Number(subscribeData),
      };

      await BasicApi.updateBasicInfo(data);
      setSaveModalOpen(false);
      toast(toastMsg.update);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>구독 관리</TableTitle>
          <TableTab02 list={pageList} style={{ marginBottom: "20px" }} />
          <DetailPage>
            <DetailPageTitle>구독 관리</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>구독 금액*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"number"}
                  placeholder={"구독 금액을 입력해주세요"}
                  value={subscribeData}
                  onChange={(e) => setSubscribeData(e.target.value)}
                />
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                text="등록하기"
                onClick={() => {
                  saveBtnHandler();
                }}
              />
            </div>
          </DetailPage>
        </TableLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          negative
          title={"금액을 변경하시겠습니까?"}
          text={
            <>
              금액 변동 사항을 사용자들에게
              <br />
              충분히 안내 후 진행할 것을 권장합니다.
              <br />
              <br />
              변경된 금액은 기존 구매자들에게 적용되지 않으며,
              <br />
              변경 이후부터 새로운 구매자들에게 한해 적용됩니다.
            </>
          }
          setModalOpen={setSaveModalOpen}
          onClick={() => {
            saveFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default SubscribeSetting;
